import { createContext } from 'react';

export const routeDefaultState = {
  route: '/'
}

export const RouteContext = createContext(routeDefaultState);